// Intersection Observer directive for scroll-triggered animations
// Usage: <div v-animate-on-scroll> or <div v-animate-on-scroll="'fade-up'">

const defaultOptions = {
  threshold: 0.15,
  rootMargin: '0px 0px -30px 0px'
}

const animationClasses = {
  'fade-up': 'animate-fade-up',
  'fade-in': 'animate-fade-in',
  'slide-left': 'animate-slide-left',
  'slide-right': 'animate-slide-right',
  'scale-in': 'animate-scale-in'
}

export function installScrollAnimations(Vue) {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    // Fallback: just show all elements immediately
    Vue.directive('animate-on-scroll', {
      inserted(el) {
        el.style.visibility = 'visible'
      }
    })
    return
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated')
        observer.unobserve(entry.target)
      }
    })
  }, defaultOptions)

  Vue.directive('animate-on-scroll', {
    inserted(el, binding) {
      const animClass = animationClasses[binding.value] || animationClasses['fade-up']
      el.classList.add('animatable', animClass)
      observer.observe(el)
    },
    unbind(el) {
      observer.unobserve(el)
    }
  })
}

export default installScrollAnimations
